import { trans } from '../../../helpers/trans';

export function createMetadataTitle(pageTitle: string): string {
    return `${pageTitle} | ${trans('basic.appName')}`;
}
